import { Teilimpfungsart } from '@/types/Teilimpfungsart';

export default class Impfdosis {
    public teilimpfungsnr!: Teilimpfungsart;
    public impfdosis_code?: string;
    public impfdb_impfartnr?: number;
    public beschreibung?: string;
    public teilimpfung?: string;
    public ordernumber?: number;

    constructor(data?: Partial<Impfdosis>) {
        Object.assign(this, data);
    }
}
